export default "__VITE_ASSET__mdhyimXt__"